module.exports = __webpack_public_path__ + "img/sri-lanka-illustration.0836faaa.webp";